function initMap() {
    const $map = document.getElementById('map');

    if ($map) {
        const lat = Number($map.getAttribute('data-lat')),
            lng = Number($map.getAttribute('data-lng')),
            locations = JSON.parse($map.getAttribute('data-locations')),
            mapIconPath = $map.getAttribute('data-map-icon'),
            mapIconActivePath = $map.getAttribute('data-map-icon-active');

        let activeMarker = null;

        let map = new google.maps.Map($map, {
            center: {lat, lng},
            zoom: 15,
            scrollwheel: false,
            mapTypeControl: false,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#7c93a3"
                        },
                        {
                            "lightness": "-10"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#a0a4a5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#62838e"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#e1e2de"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#3f4a51"
                        },
                        {
                            "weight": "0.30"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.government",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#d7e8d5",
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi.place_of_worship",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.school",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.sports_complex",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#bbcacf"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "lightness": "0"
                        },
                        {
                            "color": "#bbcacf"
                        },
                        {
                            "weight": "0.50"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#a9b4b8"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "invert_lightness": true
                        },
                        {
                            "saturation": "-7"
                        },
                        {
                            "lightness": "3"
                        },
                        {
                            "gamma": "1.80"
                        },
                        {
                            "weight": "0.01"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#a3c7df"
                        }
                    ]
                }
            ]
        });

        let customMarkerSvg = {
            url: mapIconPath,
            scaledSize: new google.maps.Size(74, 74)
        };

        if (locations) {
            for (let i = 0; i < locations.length; i++) {
                let location = locations[i],
                    lat = Number(location.position_on_the_map.lat),
                    lng = Number(location.position_on_the_map.lng);
                let marker = new google.maps.Marker({
                    position: {lat, lng},
                    map: map,
                    title: location.title,
                    icon: customMarkerSvg
                });

                let infowindow = new google.maps.InfoWindow({
                    content: `
            <div class="map-tooltip">
            <img class="map-tooltip__img" src="${location.image.sizes.medium_large}" alt="Tooltip Image">
            <p class="map-tooltip__title">${location.title}</p>
            <p class="map-tooltip__address">${location.address}</p>
            <a class="map-tooltip__phone" href="${location.phone.url}" 
            target="${location.phone.target}">${location.phone.title}</a>
            </div>
            `
                });

                marker.addListener('click', function () {
                    if (activeMarker !== null) {
                        activeMarker.infowindow.close();
                        activeMarker.setIcon(customMarkerSvg);
                    }

                    infowindow.open(map, this);

                    google.maps.event.addListenerOnce(infowindow, 'domready', function () {
                        const iwOuter = document.querySelector('.gm-style-iw');
                        const iwHeight = iwOuter.clientHeight;
                        infowindow.setOptions({pixelOffset: new google.maps.Size(0, iwHeight + 80)});
                    });

                    let newIcon = {
                        url: mapIconActivePath,
                        scaledSize: new google.maps.Size(100, 100)
                    };
                    this.setIcon(newIcon);

                    activeMarker = this;
                    activeMarker.infowindow = infowindow;
                });
            }
        }
    }
}

initMap();